import { FaTimes } from 'react-icons/fa';

interface IProps {
  errorBag: string[];
  closeError?: () => any;
}

const RenderErrorBag: React.FC<IProps> = ({ errorBag, closeError }) => {
  return (
    <div
      className={`w-full text-sm text-white text-left bg-red-500 px-4 py-2 my-4 rounded-md flex justify-between items-center`}
    >
      <div>
        {errorBag.map((errorInstance, i) => (
          <span className="w-full flex flex-col py-1" key={i}>
            {errorInstance.charAt(0).toUpperCase() + errorInstance.slice(1)}
          </span>
        ))}
      </div>
      {closeError != null && (
        <div>
          <FaTimes color="white" onClick={() => closeError()} />
        </div>
      )}
    </div>
  );
};

export default RenderErrorBag;
